import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot } from '@angular/router';

import { map, take } from 'rxjs/operators';

import { FeedAdvice } from '../models/feed-advice.model';
import { FeedAdviceService } from '../services/feed-advice.service';

@Injectable()
export class GetFeedAdviceByIdResolver {
  constructor(private feedAdviceService: FeedAdviceService) {}

  resolve(route: ActivatedRouteSnapshot) {
    return this.feedAdviceService.getFeedAdviceById(Number(route.paramMap.get('id'))).pipe(
      take(1),
      map((feedadvice: FeedAdvice) => feedadvice),
    );
  }
}
